<script>
export default {
  name: "SJanela",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Janela",
    },
    width: {
      type: Number,
      default: 800,
    },
    height: {
      type: Number,
      default: 500,
    },
    showBarra: {
      type: Boolean,
      default: true,
    },
    btMi: {
      type: Boolean,
      default: false,
    },
    btMa: {
      type: Boolean,
      default: false,
    },
    btFe: {
      type: Boolean,
      default: true,
    },
    isResponsive: {
      type: Boolean,
      default: true,
    },
    dad: {
      type: Object,
      default: null,
    },
    maximize: {
      type: Boolean,
      default: false,
    },
    centerOnShow: {
      type: Boolean,
      default: true,
    },
  },
  emits: [
    "before-close",
    "opened",
    "close",
  ],

  data() {
    return {
      hdl: null,
      janelaId: null,
    };
  },

  watch: {
    visible: {
      handler(newVal) {
        if (newVal && !this.hdl) {
          this.createJanela();
        } else if (!newVal && this.hdl) {
          this.closeJanela();
        }
      },
      immediate: true,
    },
  },

  beforeDestroy() {
    this.closeJanela();
  },

  methods: {
    createJanela() {
      this.hdl = globalThis.Yanda.newJanela({
        title: this.title,
        showBarra: this.showBarra,
        btMi: this.btMi,
        btMa: this.btMa,
        btFe: this.btFe,
        isResponsive: this.isResponsive,
        dad: this.dad,
      });
      this.janelaId = this.hdl.uniqid;

      // Cria o template com portal-target
      const template = `
        <div id="${this.janelaId}-content" style="height: 100%; display: flex; flex-direction: column;">
          <portal-target
            :name="'${this.janelaId}'"
            style="display: flex; flex: 1; flex-direction: column;"
          ></portal-target>
        </div>
      `;

      this.hdl.setContent(template);

      this.hdl.setTamanho(this.width, this.height);

      if (this.centerOnShow) {
        this.hdl.centraliza();
      }

      if (this.maximize) {
        this.hdl.maximize();
      }

      this.hdl.vue = new Vue({
        el: this.hdl.$(`${this.janelaId}-content`),
        provide: {
          hdl: this.hdl,
        },
      });

      this.hdl.onBeforeClose = () => {
        this.$emit("before-close");
        return true;
      };

      this.hdl.onClose = () => {
        this.handleClose();
      };

      this.hdl.show();

      this.$emit("opened", this.hdl);
    },

    closeJanela() {
      if (this.hdl) {
        if (this.hdl.vue?._isVue) {
          this.hdl.vue.$destroy();
          this.hdl.vue = null;
        }

        this.hdl?.close();
        this.hdl = null;
        this.janelaId = null;
      }
    },

    handleClose() {
      this.hdl = null;
      this.janelaId = null;
      this.$emit("close");
    },
  },
};
</script>

<template>
  <div v-if="visible && janelaId">
    <portal :to="janelaId">
      <slot :hdl="hdl"></slot>
    </portal>
  </div>
</template>